import { useEffect, Component } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import RecruitingPage from "@/pages/RecruitingPage";
import SchedulePage from "@/pages/SchedulePage";
import RosterPage from "@/pages/RosterPage";
import RecruitProfilePage from "@/pages/RecruitProfilePage";
import CampsPage from "@/pages/CampsPage";
import ContactPage from "@/pages/ContactPage";
import AdminPage from "@/pages/AdminPage";

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const timer = setTimeout(() => {
        document.querySelector(hash)?.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 400);
      return () => clearTimeout(timer);
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { err: false };
  }
  static getDerivedStateFromError() {
    return { err: true };
  }
  render() {
    if (this.state.err) {
      return (
        <div className="grid min-h-screen place-items-center bg-navy-900 px-6 text-center">
          <div>
            <img src="/logo.png" alt="ASA" className="mx-auto h-16 w-16 object-contain" />
            <p className="mt-6 font-display text-2xl font-bold uppercase text-white">Something went wrong</p>
            <p className="mt-2 text-sm text-slate-400">Reload the page to get back in the game.</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.11, smoothWheel: true });
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <ErrorBoundary>
      <BrowserRouter>
        <ScrollManager />
        <div className="grain min-h-screen bg-navy-900 font-sans text-slate-100 antialiased">
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/recruiting" element={<RecruitingPage />} />
              <Route path="/schedule" element={<SchedulePage />} />
              <Route path="/roster" element={<RosterPage />} />
              <Route path="/roster/:id" element={<RecruitProfilePage />} />
              <Route path="/camps" element={<CampsPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="*" element={<HomePage />} />
            </Routes>
          </main>
          <Footer />
          <Toaster
            theme="dark"
            position="bottom-right"
            richColors
            toastOptions={{
              style: {
                background: "#131D33",
                border: "1px solid rgba(226,232,240,0.14)",
                color: "#F8FAFC",
              },
            }}
          />
        </div>
      </BrowserRouter>
    </ErrorBoundary>
  );
}
